import RootState from '../../../typings/RootState'
import { Event } from '../../types/event'
import { Data } from './types'

export const selectData = (state: RootState): Data => state.cmpjChecking.data
export const selectEvent = (state: RootState): Event => state.cmpjChecking.event
